(() => {
	angular.module('main').directive('jobCellHeader', jobCellHeader);

	function jobCellHeader() {
		return {
			restrict: 'E',
			scope: {
				icon: '@',
				imgSrc: '@',
				text: '@',
				isBorderBottom: '@',
				files: '=',
				galleryHeader: '<'
			},
			template: ` 
                  <div class="main-jobs-cell__title" ng-class="{'main-jobs-cell__title--bordered' : isBorderBottom}">
                    <i class="{{icon}}" ng-if="icon"></i>
                    <img ng-src="{{imgSrc}}" ng-if="imgSrc">
                    <h2>{{text}}</h2>
                    <sn-label
                    ng-if="galleryHeader"
                        text="Connected to ShootProof">
                    </sn-label>
                    <ng-transclude style="margin-left: auto"></ng-transclude>
                  </div>
            `,
			replace: true,
			transclude: true
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/pageJob/jobCellHeader.js